module.exports = __webpack_public_path__ + "img/twlhc_icon.30e42593.png";